/* eslint-disable no-unused-vars */
import React from 'react';
import "./MixingProcess.css";


function MixingProcess() {
  return (
    <div className='mixingprocess-container'>
      <div className="mixingprocess-content">

        <div className='mixingprocess-header'>
          <h3>KARIŞIM PROSESİ</h3>
        </div>
        <div className='pro-text-promotion'>
          <h3>KARIŞIM PROSESİ</h3>
          <p>  High Performance Compound Kauçuk A.Ş Bursa Hasanağa OSB bölgesinde 2017 yılından itibaren 5600m²’ si kapalı olmak üzere toplam 8000m² alan üzerine kurulu tesisi ile hizmet vermektedir. 2 adet mikser hattı ile yıllık 7.000t karışım üretme kapasitesine sahiptir.</p>
          <p>Üretim esnekliğimiz, maksimum esneklik, hızlı müdahale ve çapraz kontaminasyonun ortadan kaldırılması için fiziksel olarak ayrılan hatlarda faydalanmaktadır. Pomini PN80 80L tanjantal rotorlu ve Pomini VIC165 165L intermeshing rotorlu 2 adet karışım hattı bulunmaktadır.</p>
          <p>Pazar yaklaşımımız, sadece otomotiv endüstrisinden değil, diğer zorlu segmentlerden de en sıkı ve güncel özellikleri karşılamak için geliştirilmiş yüksek teknoloji performans bileşiklerinin teklifine dayanmaktadır.</p>
          <p>Tüm reçetelerimiz sadece spesifikasyonları ve standartları yerine getirmek için değil, aynı zamanda müşterilerimizin özel dönüşme ihtiyaçlarına uygun olarak kalite ve kalıplanabilirlik arasındaki en iyi dengeye ve optimizasyona uyacak şekilde tasarlanmıştır.</p>
        </div>

      
      </div>
    </div>
  )
}

export default MixingProcess